import jwtDecode from 'jwt-decode'
import { isEmpty } from 'validator'
import { AccessLevel } from './types'
import { getAccessToken } from './getAccessToken'
import { getBearerToken } from './getBearerToken'

// Add debugging
console.log('Loading credentials module')

interface IToken {
  accessLevel: AccessLevel
  userId: string
  iat: number
  exp: number
}

export const getCurrentAccessLevel = (): AccessLevel => {
  try {
    console.log('Getting current access level')
    const accessToken = getAccessToken()
    console.log(
      'Access token for level check:',
      accessToken ? 'present' : 'not present'
    )

    if (isEmpty(accessToken || '')) {
      console.log('No access token, returning default AccessLevel.User')
      return AccessLevel.User
    }

    try {
      console.log('Attempting to decode access token')
      const decoded = jwtDecode(accessToken) as IToken
      console.log('Token successfully decoded')

      if (!decoded || typeof decoded !== 'object') {
        console.error('Token decoded but invalid format:', typeof decoded)
        return AccessLevel.User
      }

      if (!decoded.accessLevel) {
        console.error('Token decoded but missing accessLevel')
        return AccessLevel.User
      }

      console.log('Access level from token:', decoded.accessLevel)
      return decoded.accessLevel
    } catch (decodeError) {
      console.error('Error decoding token:', decodeError)
      return AccessLevel.User
    }
  } catch (error) {
    console.error('Error getting access level:', error)
    return AccessLevel.User
  }
}

export const getCurrentUserId = (): string => {
  try {
    console.log('Getting current user ID')
    const accessToken = getAccessToken()
    console.log(
      'Access token for userId check:',
      accessToken ? 'present' : 'not present'
    )

    if (isEmpty(accessToken || '')) {
      console.log('No access token, returning empty user ID')
      return ''
    }

    try {
      console.log('Attempting to decode access token for user ID')
      const decoded = jwtDecode(accessToken) as IToken

      if (!decoded || typeof decoded !== 'object') {
        console.error(
          'Token decoded but invalid format for user ID:',
          typeof decoded
        )
        return ''
      }

      if (!decoded.userId) {
        console.error('Token decoded but missing userId')
        return ''
      }

      console.log('User ID from token:', decoded.userId)
      return decoded.userId
    } catch (decodeError) {
      console.error('Error decoding token for user ID:', decodeError)
      return ''
    }
  } catch (error) {
    console.error('Error getting user ID:', error)
    return ''
  }
}

export const getCurrentEmailAddress = (): string => {
  try {
    console.log('Getting current email address')
    const accessToken = getBearerToken()
    console.log(
      'Bearer token for email check:',
      accessToken ? 'present' : 'not present'
    )

    if (isEmpty(accessToken || '')) {
      console.log('No bearer token, returning empty email')
      return ''
    }

    try {
      console.log('Attempting to decode token for email')
      const decoded = jwtDecode(accessToken) as any

      if (!decoded || typeof decoded !== 'object') {
        console.error(
          'Token decoded but invalid format for email:',
          typeof decoded
        )
        return ''
      }

      if (!decoded.emailAddress) {
        console.error('Token decoded but missing emailAddress')
        return ''
      }

      console.log('Email from token found')
      return decoded.emailAddress
    } catch (decodeError) {
      console.error('Error decoding token for email:', decodeError)
      return ''
    }
  } catch (error) {
    console.error('Error getting email address:', error)
    return ''
  }
}

export const accessTokenPresent = (): boolean => {
  try {
    const token = getAccessToken()
    console.log('Checking if access token is present:', token ? 'yes' : 'no')
    return !isEmpty(token || '')
  } catch (error) {
    console.error('Error checking if access token is present:', error)
    return false
  }
}
